module.exports = __webpack_public_path__ + "img/livev2.819713ff.png";